import { memo, useState, useMemo } from "react";
import { Table } from "antd";

const DataByProduct = ({data}) => {
    const [pageSize, setPageSize] = useState(10)

    const handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const convertCurrency = (data) => {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = useMemo(() => {
        if (!data?.listStore) return [];
        return [
            {
                title: "Dịch vụ",
                dataIndex: "product_name",
                width: 250,
                fixed: "left",
            },
            {
                title: "Tổng",
                dataIndex: "total",
                width: 160,
                fixed: "left",
                align: "center",
                render: (_, row) => {
                    return (
                        <>
                            <div style={{ fontWeight: 600 }}>{convertCurrency(row.total_revenue ?? 0)}</div>
                            <div style={{ fontSize: 12, color: "#888" }}>({row.total_count ?? 0})</div>
                        </>
                    );
                },
            },
            ...data.listStore.map((store) => ({
                title: store.name_store,
                width: 160,
                align: "center",
                render: (_, row) => {
                    const revenue = row[`${store.id}_revenue`] || 0;
                    const count = row[`${store.id}_count`] || 0;
                    return (
                        <>
                            <div style={{ fontWeight: 600 }}>{convertCurrency(revenue)}</div>
                            <div style={{ fontSize: 12, color: "#888" }}>({count})</div>
                        </>
                    );
                },
            })),
        ]
    }, [data]);

    if (!data) {
        return <div>Đang tải dữ liệu...</div>;
    }
    return (
        <div style={{ backgroundColor: "white" }} className="p-2">
            <div className="mb-2">Bảng số liệu theo ngày</div>
            <Table
                rowKey="product_id"
                columns={columns}
                dataSource={data.result}
                bordered
                scroll={{ x: 'max-content', y: 600 }}
                pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '20', '30'] }}
                onChange={handleChange}
            />
        </div>
    )
}

export default memo(DataByProduct)